export const contracts = {
  "contracts.dealers": "contracts.dealers",
  "contracts.dealers.aditional": "contracts.dealers.aditional",
  "contracts.getContracts": "contracts.getContracts",
  "contracts.createContracts": "contracts.createContracts",
  "contracts.editContracts": "contracts.editContracts",
  "contracts.history": "contracts.history",
  "contracts.getAdditional": "contracts.getAdditional",
  "contracts.createAdditional": "contracts.createAdditional",
  "contracts.editAdditional": "contracts.editAdditional",
  "contracts.getTmps": "contracts.getTmps",
  "contracts.getTmpsFields": "contracts.getTmpsFields",
  "contracts.print": "contracts.print",
  "contracts.getVasReq": "contracts.getVasReq",
  "contracts.getVasReqActive": "contracts.getVasReqActive",
} as const;
